import Loader from 'modules/Common/Loader/component';
import React from 'react';
import styled from 'styled-components';
import { ReactComponent as ExclamationRedIcon } from 'assets/icons/xpo/status_icons/girded-exclamation-red.svg';
import TooltipHeader from 'modules/emergencies/components/ui/texts/TooltipHeader';
import { Tooltip } from '@ontruck/orc';
import { PriceText } from './PriceText';
import { Content } from './Content';
import { Label } from './Label';
import { Container } from './Container';

const CenteredIconContainer = styled.div`
  span {
    display: flex;
  }
`;

const PriceDisplay = ({ label, errorMsg, price, isLoading, hasError, isReadonly }) => {
  return (
    <Container isReadonly={isReadonly}>
      <Label>{label}</Label>
      <Content isReadonly={isReadonly}>
        {isLoading && !hasError && (
          <figure aria-label="Loader">
            <Loader />
          </figure>
        )}
        {hasError && (
          <CenteredIconContainer>
            <Tooltip
              component={<TooltipHeader>{errorMsg}</TooltipHeader>}
              position="top"
              skin="dark"
            >
              <ExclamationRedIcon title="Error icon" />
            </Tooltip>
          </CenteredIconContainer>
        )}
        {!isLoading && !hasError && price && <PriceText>{price}</PriceText>}
      </Content>
    </Container>
  );
};

export default PriceDisplay;
